import Grid from "@mui/material/Grid";
import { useAuth } from "../../core/context/auth.context";
import useScreenSize from "../../core/hooks/use-screen-size";
import useUserOs from "../../core/hooks/use-user-os";
import UserDebtsListComponent from "../user-debts-list.component";
import Typography from "@mui/material/Typography";
import { useQuery } from "@tanstack/react-query";
import UserService from "../../core/service/user.service";
import formatCurrency from "../../core/helpers/format-currency.helper";
import { Skeleton } from "@mui/material";

export default function MyDebtsTab() {
  const { user } = useAuth();
  const screenSize = useScreenSize();
  const { isIOS } = useUserOs();

  const innerContainerSize = screenSize.height - (isIOS ? 180 : 165); // magic numbers
  const userService = new UserService();

  const { data: userStats, refetch } = useQuery({
    queryKey: [`singleUserData`, { userId: user!.id }],
    queryFn: () => userService.getStats(user!.id),
    initialData: undefined,
  });

  const onDebtChange = async () => {
    await refetch();
  };

  if (!user) {
    return null;
  }
  return (
    <Grid
      item
      xs={12}
      height="80vh"
      style={{
        borderRadius: 15,
      }}
    >
      <Typography
        textAlign="center"
        style={{
          textShadow: "none",
          fontWeight: 300,
          padding: 10,
          marginBottom: 10,
          color: "#fff",
        }}
      >
        {!userStats?.data && (
          <Skeleton variant="text" sx={{ fontSize: "1.6rem" }} />
        )}
        {userStats?.data && (
          <>
            My total debts:{" "}
            <Typography color="error" fontWeight="500" display="inline">
              {formatCurrency(userStats?.data?.debts, "USD")}
            </Typography>
          </>
        )}
      </Typography>
      <UserDebtsListComponent
        height={innerContainerSize - 120}
        type="users"
        onDebtChange={onDebtChange}
        pageSize={Math.floor((innerContainerSize - 100) / 80)}
      />
    </Grid>
  );
}
